<template>
  <div>
    <van-row class="m-t-3">
      <van-col :span="22" :offset="1">
        <van-row>
          <!-- 详情头部信息 -->
          <van-col :span="24" class="bg-white p-075 b-r-3 bs">
            <van-image
              width="6.2rem"
              height="3.5rem"
              :src="order.coverPictureUrl"
              class="f-l-l"
            />
            <div class="f-l-l m-l-02" style="width: 59%">
              <div class="van-multi-ellipsis--l2">
                <p class="f-l-l payTag f-s-6 text-c">{{ order.itname }}</p>
                <p class="payTitle f-s-16">{{ order.cname }}</p>
              </div>
              <p class="text-r f-s-16">¥{{ order.coursePrice }}</p>
            </div>
          </van-col>
          <!-- 优惠 -->
          <van-col :span="24" class="bg-white p-075 b-r-3 bs m-t-05">
            <Disc />
          </van-col>
          <!-- 支付方式 -->
          <van-col :span="24" class="bg-white p-075 b-r-3 bs m-t-05">
            <Pay ref="pay" />
          </van-col>
          <!-- 商品总额 -->
          <van-col :span="24" class="bg-white p-075 b-r-3 bs m-t-05">
            <p class="f-s-16">
              商品总额<span class="f-l-r">¥{{ order.coursePrice }}</span>
            </p>
          </van-col>
        </van-row>
      </van-col>
    </van-row>

    <!-- 去支付 -->
    <div class="Footer">
      <van-row class="payFoot">
        <van-col :span="24">
          <p class="f-s-16 m-l-1 m-t-10 f-l-l">应付:</p>
          <p class="f-s-12 f-l-l m-t-07" style="color: #fc7d16">
            ¥{{ order.discountPrice }}
          </p>
          <van-button
            type="danger"
            class="xz-button-info playGroup m-t-045 b-r-013 f-l-r m-r-075"
            style="width: 40%"
            @click="goBuy()"
          >
            <p>¥{{ order.discountPrice }}</p>
            <p>立即支付</p>
          </van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Disc from "@/components/class/pay/disc";
import Pay from "@/components/class/pay/pay";
import { getAppClient } from "@/utils/commonUtils";
import { Dialog } from "vant";

export default {
  /* eslint-disable */
  components: {
    Disc,
    Pay,
  },
  data() {
    return {
      calcInfo: {
        cid: "",
        acttypeid: "",
      },
      order: {},
    };
  },
  created() {
    let query = this.$route.query;
    this.calcInfo.cid = query.cid;
    this.calcInfo.acttypeid = query.acttypeid *1;
    this.generateOrder();
  },
  methods: {
    generateOrder() {
      let data = this.calcInfo;
      let belongGroupId = this.$route.query.belongGroupId;
      if (belongGroupId != "") {
        data.orderGroupId = belongGroupId;
      }
      this.Api({
        url: "api/order/generateOrder",
        method: "POST",
        data,
      }).then((res) => {
        this.order = res.data;
      });
    },
    goBuy() {
      let query = this.$route.query;
      let data = {
        orderNumber: this.order.orderNumber,
        pid: getAppClient() == "JSAPI" ? "3" : this.$refs.pay.payFals, //支付方式 1.微信/2.支付宝
      };
      if (getAppClient() == "JSAPI") {
        data.openid = this.$refs.pay.wxOpendId;
      }
      if (query.belongGroupId != undefined) {
        // 如果归属的id不为空
        data.belongGroupId = query.belongGroupId;
      }
      if(this.order.state == "2"){
        this.$router.push({
          path: "/classPayResult",
          query: {
            isPay: true,
            cid: this.$route.query.cid,
            orderNumber: this.order.orderNumber,
            type: "2",
            status:this.order.status
          },
        });
        return false
      }
      this.Api({
        url: "api/order/toPay",
        method: "POST",
        data,
      }).then((res) => {
        if (getAppClient() == "JSAPI") {
          let _this = this;
          let dataTow = res.data;
          _this.order.orderNumber = dataTow.orderNo
          wx.ready(function () {
            wx.chooseWXPay({
              timestamp: dataTow.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: dataTow.nonceStr, // 支付签名随机串，不长于 32 位
              package: dataTow.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
              signType: dataTow.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: dataTow.paySign, // 支付签名
              success: function () {
                _this.$router.push({
                  path: "/classPayResult",
                  query: {
                    isPay: true,
                    cid: _this.$route.query.cid,
                    orderNumber: dataTow.orderNo,
                    type: "2",
                    status:dataTow.status
                  },
                });
              },
              fail: function (res) {
                // window.location.replace(location.href)
                console.log("res----", res);
              },
              cancel: function (res) {
                // window.location.replace(location.href)
                console.log("支付验证err", res);
              },
            });
          });
          wx.error(function (res) {
            Dialog.confirm({
              message: "失败",
              confirmButtonText:"确定",
              cancelButtonText: "回首页",
            }).then(() => {
                location.reload();
            }).catch(() => {
              this.$router.push({
                path: "/",
              });
            });
          });
        } else {
          window.location.href = res.data.payUrl;
        }
      }).catch((e) => {});
    },
  },
};
</script>

<style scoped>
.Footer {
  position: fixed;
  bottom: 0px;
  height: 3.5rem;
  background-color: white;

  box-shadow: 0rem -0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.08);
  width: 100%;
}
.payTag {
  background: #858e9b;
  border-radius: 0.1rem;
  width: 1.6rem;
  color: #ffffff;
}
.payTitle {
  color: #292e35;
  text-indent: 0.4rem;
  line-height: 1rem;
}
.bs {
  box-shadow: 0rem 0rem 0.75rem 0.1rem rgba(0, 6, 22, 0.04);
}
</style>